"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const castNumberToCoordinate_1 = __importDefault(require("../../../shared/castNumberToCoordinate"));
const getNumberFromUnknown_1 = __importDefault(require("../../../shared/getNumberFromUnknown"));
const reduceValidMarkers = (markers) => Object.entries(markers)
    .reduce((newMarkers, [markerId, marker]) => {
    const latitudeValue = (0, castNumberToCoordinate_1.default)(marker.latitude);
    const longitudeValue = (0, castNumberToCoordinate_1.default)(marker.longitude);
    let degrees;
    try {
        degrees = (0, getNumberFromUnknown_1.default)(marker.degrees || 0);
    }
    catch (_a) {
        degrees = 0;
    }
    if (latitudeValue && longitudeValue) {
        return Object.assign(Object.assign({}, newMarkers), { [markerId]: {
                coordinate: {
                    latitude: latitudeValue,
                    longitude: longitudeValue,
                },
                title: marker.title || undefined,
                description: marker.description || undefined,
                rotation: marker.rotation || undefined,
                image: marker.image || undefined,
                width: marker.width || 30,
                height: marker.height || 30,
                degrees: degrees >= 0 || degrees <= 360 ? degrees : 0,
            } });
    }
    return newMarkers;
}, {});
exports.default = reduceValidMarkers;
